import { CarCoverage } from 'Types/coverages/coverages.types';
import {
  OwnContributionCode,
  OwnContributionValue,
} from './components/OwnContribution/ownContribution.constants';

export interface ChangeCarFormValues {
  coverage: CarCoverage;
  rentalType: RentalType;
  yearlyKmNeed: string;
  mileage: number;
  ownContribution: OwnContributionValue | undefined;
  ownContributionCode: OwnContributionCode | undefined;
  usedByYoungerDriver: boolean;
}

export const carValuesToShowInBlueBox = [
  'coverage',
  'rentalType',
  'yearlyKmNeed',
  'mileage',
  'ownContribution',
  'ownContributionCode',
  'usedByYoungerDriver',
];

export interface ChangeCarPriceRequest {
  coverage: CarCoverage;
  rentalCarIncluded: boolean | undefined;
  rentalType: RentalType | null | undefined;
  yearlyKmNeed: string;
  ownContribution?: number;
  ownContributionCode: OwnContributionCode | undefined;
  usedByYoungerDriver: boolean;
  mileage: number;
}

export type ChangeCarPriceMapper = ChangeCarPriceRequest;

export interface ChangeCarInsuranceRequest {
  coverage: CarCoverage;
  rentalCarIncluded: boolean | undefined;
  rentalType: RentalType | null | undefined;
  yearlyKmNeed: string;
  ownContribution?: number;
  ownContributionCode?: OwnContributionCode;
  usedByYoungerDriver: boolean;
  mileage: number;
}

export enum RentalType {
  RENTAL_TYPE_NON = 'RENTAL_TYPE_NON',
  RENTAL_TYPE_ORDINARY = 'RENTAL_TYPE_ORDINARY',
  RENTAL_TYPE_EXTENDED = 'RENTAL_TYPE_EXTENDED',
}

export interface CoverageOption {
  id: string;
  label: string;
  trackid: string;
  value: string;
  disabled?: boolean;
}

interface CoverageConfigOptions {
  default: CoverageOption[];
  mortgagee: CoverageOption[];
  olderThan7: CoverageOption[];
  notOlderThan7: CoverageOption[];
  olderThan10: CoverageOption[];
  notOlderThan10: CoverageOption[];
}

export interface CoverageConfig {
  [key: string]: CoverageConfigOptions;
}
